var map = {
	"./DongGoi.svg": 5782,
	"./KichHoatTem.svg": 5783,
	"./NhatKy.svg": 5784,
	"./agri.png": 5785,
	"./agri.svg": 5786,
	"./bag.svg": 5787,
	"./baoQuan.svg": 5788,
	"./baoTrai.svg": 5789,
	"./bao_trai.png": 5790,
	"./bitcoin.svg": 5791,
	"./blockchain.svg": 5792,
	"./bottle.svg": 5793,
	"./box.svg": 5794,
	"./bubble-chat.png": 5795,
	"./bud.svg": 5796,
	"./chamSocDacBiet.svg": 5797,
	"./chat.png": 5798,
	"./cherry.svg": 5799,
	"./chinhThongSo.svg": 5800,
	"./chonLoc.svg": 5801,
	"./chonNguyenLieu.svg": 5802,
	"./chuanBiVaoLoLenMen.svg": 5803,
	"./cold.svg": 5804,
	"./cold2.svg": 5805,
	"./coldtomato.svg": 5806,
	"./dangKyCay.svg": 5807,
	"./defaultIcon.svg": 5808,
	"./delivery-package-opened.png": 5809,
	"./delivery-truck.svg": 5810,
	"./delivery.svg": 5811,
	"./emoji/angry-face.svg": 218,
	"./emoji/expressionless -face.svg": 219,
	"./emoji/smiling-face.svg": 220,
	"./fermentation.svg": 5812,
	"./fertilizer.svg": 5813,
	"./filter.svg": 5814,
	"./floss.svg": 5815,
	"./fruit.svg": 5816,
	"./garlic.svg": 5817,
	"./ghepCay.svg": 5818,
	"./giaohang.svg": 5819,
	"./gieoGiong.svg": 5820,
	"./gmo.svg": 5821,
	"./grinder.svg": 5822,
	"./harvest.svg": 5823,
	"./home.svg": 5824,
	"./honeycomb.svg": 5825,
	"./ibl.png": 5826,
	"./invoice.svg": 5827,
	"./khaosat.svg": 5828,
	"./kiemTraChatLuong.svg": 5829,
	"./lamSach.svg": 5830,
	"./lenmen.svg": 5831,
	"./location.svg": 288,
	"./logo_agridential_white.png": 5832,
	"./magnifier.svg": 84,
	"./mango.svg": 5833,
	"./mixer.svg": 5834,
	"./ngamNuoc.svg": 5835,
	"./nguyenLieu.svg": 5836,
	"./nhansam.png": 5837,
	"./oven.svg": 5838,
	"./pesticide.svg": 5839,
	"./phanLoai.svg": 5840,
	"./phoiChamTrenGian.svg": 5841,
	"./phoiKho.svg": 5842,
	"./picking.svg": 5843,
	"./process.svg": 5844,
	"./qrCode.svg": 5845,
	"./raLoXuLyBanThanhPham.svg": 5846,
	"./rang.svg": 5847,
	"./rangHat.svg": 5848,
	"./register.svg": 5849,
	"./rua.svg": 5850,
	"./sell.svg": 5851,
	"./shovel.svg": 5852,
	"./snowflake.svg": 5853,
	"./soChe1.svg": 5854,
	"./soChe2.svg": 5855,
	"./sort-down.png": 111,
	"./sort-up.png": 112,
	"./sort-up.svg": 5856,
	"./sort.svg": 5857,
	"./spray.svg": 5858,
	"./sprinkler.svg": 5859,
	"./sprout.svg": 5860,
	"./store.svg": 5861,
	"./sun.svg": 5862,
	"./svgtopng/DongGoi.svg": 5863,
	"./svgtopng/KichHoatTem.svg": 5864,
	"./svgtopng/NhatKy.svg": 5865,
	"./svgtopng/bag.svg": 5866,
	"./svgtopng/baoQuan.svg": 5867,
	"./svgtopng/baoTrai.svg": 5868,
	"./svgtopng/chamSocDacBiet.svg": 5869,
	"./svgtopng/chinhThongSo.svg": 5870,
	"./svgtopng/chonLoc.svg": 5871,
	"./svgtopng/chonNguyenLieu.svg": 5872,
	"./svgtopng/chuanBiVaoLoLenMen.svg": 5873,
	"./svgtopng/dangKyCay.svg": 5874,
	"./svgtopng/defaultIcon.svg": 5875,
	"./svgtopng/delivery.svg": 5876,
	"./svgtopng/fertilizer.png": 5877,
	"./svgtopng/fertilizer.svg": 5878,
	"./svgtopng/ghepCay.svg": 5879,
	"./svgtopng/giaohang.svg": 5880,
	"./svgtopng/gieoGiong.svg": 5881,
	"./svgtopng/harvest.png": 5882,
	"./svgtopng/invoice.svg": 5883,
	"./svgtopng/kiemTraChatLuong.svg": 5884,
	"./svgtopng/lamSach.svg": 5885,
	"./svgtopng/lenMen.svg": 5886,
	"./svgtopng/ngamNuoc.svg": 5887,
	"./svgtopng/nguyenLieu.svg": 5888,
	"./svgtopng/pesticide.png": 5889,
	"./svgtopng/phanLoai.svg": 5890,
	"./svgtopng/phoiChamTrenGian.svg": 5891,
	"./svgtopng/phoiKho.svg": 5892,
	"./svgtopng/raLoXuLyBanThanhPham.svg": 5893,
	"./svgtopng/rua.svg": 5894,
	"./svgtopng/soChe1.svg": 5895,
	"./svgtopng/soChe2.svg": 5896,
	"./svgtopng/spray.svg": 5897,
	"./svgtopng/sprinkler.svg": 5898,
	"./svgtopng/thanhPham.svg": 5899,
	"./svgtopng/thuHoach.svg": 5900,
	"./svgtopng/thuHoachCF.svg": 5901,
	"./svgtopng/tronBot.svg": 5902,
	"./svgtopng/tuoiNuoc.svg": 5903,
	"./svgtopng/uHat.svg": 5904,
	"./svgtopng/vienThanhNu.svg": 5905,
	"./svgtopng/xayThanhBot.svg": 5906,
	"./tachbot.svg": 5907,
	"./test.svg": 5908,
	"./thanhPham.svg": 5909,
	"./thuHoach.svg": 5910,
	"./thuHoachCF.svg": 5911,
	"./tomato.svg": 5912,
	"./tree.svg": 5913,
	"./tronBot.svg": 5914,
	"./tuoiNuoc.svg": 5915,
	"./uHat.svg": 5916,
	"./us.svg": 289,
	"./vegetable.svg": 5917,
	"./vienThanhNu.svg": 5918,
	"./vietnam.svg": 221,
	"./warehouse.svg": 5919,
	"./water-drop.png": 5920,
	"./water-drop.svg": 5921,
	"./water.svg": 5922,
	"./xayThanhBot.svg": 5923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 243;